import {
    getDefaultMarket,
    getDefaultRegion,
} from '../service/stocks';
import {
    CHANGE_MARKET,
    CHANGE_RANK,
    FETCH_DATA,
    NEW,
    RELOAD,
    ERROR,
    RESET,
    SHOW_ALL,
    UPDATE,
} from '../actions/overview';

const region = getDefaultRegion();
const selectedMarket = getDefaultMarket(region.id);
const initialState = {
    selectedMarket,
    currentRank: '-CHANGE_PCT',
    symbols: [],
    isFetching: false,
    ready: false,
    reloading: false,
    error: false,
    limit: 5,
};

export default function overview(state = initialState, action) {
    switch (action.type) {
    case RESET:
        return Object.assign({}, state, {
            selectedMarket,
            currentRank: '-CHANGE_PCT',
            error: false,
            isFetching: false,
            limit: 5,
            ready: false,
            reloading: false,
            symbols: [],
        });
    case SHOW_ALL:
        return Object.assign({}, state, {
            limit: 10,
        });
    case CHANGE_MARKET:
        return Object.assign({}, state, {
            selectedMarket: action.market,
            reloading: true,
            limit: 5,
        });

    case CHANGE_RANK:
        return Object.assign({}, state, {
            currentRank: action.rank,
        });

    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            isFetching: true,
            ready: false,
        });

    case FETCH_DATA.SUCCESS:
        return Object.assign({}, state, {
            isFetching: false,
            error: false,
            ready: true,
            symbols: action.payload,
        });

    case FETCH_DATA.FAILURE:
        return Object.assign({}, state, {
            isFetching: false,
            ready: false,
            error: true,
        });

    case RELOAD:
        return Object.assign({}, state, {
            isFetching: true,
            reloading: true,
            ready: false,
        });

    case NEW:
        return Object.assign({}, state, {
            isFetching: false,
            ready: true,
            error: false,
            reloading: false,
            symbols: action.payload,
        });

    case ERROR:
        return Object.assign({}, state, {
            isFetching: false,
            ready: false,
            reloading: false,
            error: true,
        });

    case UPDATE:
        return Object.assign({}, state, {
            symbols: state.symbols.map(symbol => {
                if (symbol.key === action.key) {
                    return {
                        key: symbol.key,
                        values: Object.assign({}, symbol.values, action.values),
                    };
                }

                return symbol;
            }),
        });

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/overview.js
 **/